"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * New Relic Doc: https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api
 * */
exports.isNrAvailable = function () { return window && window.newrelic; };
exports.nrAddRelease = function (name, version) {
    if (exports.isNrAvailable()) {
        window.newrelic.addRelease(name, version);
    }
};
exports.nrAddPageAction = function (name, data) {
    if (exports.isNrAvailable()) {
        window.newrelic.addPageAction(name, data);
    }
};
exports.nrAddToTrace = function (name, data) {
    if (data === void 0) { data = {}; }
    if (exports.isNrAvailable()) {
        var start = Date.now();
        window.newrelic.addToTrace(__assign({ name: name, start: start }, data));
    }
};
exports.nrNoticeError = function (error, data) {
    if (data === void 0) { data = {}; }
    if (exports.isNrAvailable()) {
        window.newrelic.noticeError(error, data);
    }
};
exports.nrSetCustomAttribute = function (name, val) {
    if (exports.isNrAvailable()) {
        window.newrelic.setCustomAttribute(name, val);
    }
};
exports.nrSetPageViewName = function (name, val) {
    if (exports.isNrAvailable()) {
        window.newrelic.setPageViewName(name, val);
    }
};
//# sourceMappingURL=index.js.map